import { expenseCategory, arrayOfExpenseCategories } from "~/schemas/schema.expense_categories";
import * as actionTypes from "~/store/action_types";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const fetchExpenseCategory = (id) => {
  return {
    types: [
      actionTypes.FETCH_EXPENSE_CATEGORY_LOADING,
      actionTypes.FETCH_EXPENSE_CATEGORY_SUCCESS,
      actionTypes.FETCH_EXPENSE_CATEGORY_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/expense-categories/${id}`,
      }),
    payload: {
      id,
      schema: {
        single: expenseCategory,
      },
    },
  };
};

export const addExpenseCategoryAction = (attributes) => ({
  types: [
    actionTypes.ADD_EXPENSE_CATEGORY_LOADING,
    actionTypes.ADD_EXPENSE_CATEGORY_SUCCESS,
    actionTypes.ADD_EXPENSE_CATEGORY_ERROR,
  ],
  callAPI: () =>
    fetch({
      url: `${Angie.api_url}/expense-categories`,
      method: "POST",
      body: attributes,
    }),
  payload: {
    ...attributes,
    schema: {
      single: expenseCategory,
    },
  },
});

export const fetchExpenseCategoriesAction = () => ({
  types: [
    actionTypes.FETCH_EXPENSE_CATEGORIES_LOADING,
    actionTypes.FETCH_EXPENSE_CATEGORIES_SUCCESS,
    actionTypes.FETCH_EXPENSE_CATEGORIES_ERROR,
  ],
  callAPI: () =>
    fetch({
      url: `${Angie.api_url}/expense-categories`,
    }),
  payload: {
    schema: arrayOfExpenseCategories,
  },
});

export const editExpenseCategoryAction = (id, attributes) => ({
  types: [
    actionTypes.EDIT_EXPENSE_CATEGORY_LOADING,
    actionTypes.EDIT_EXPENSE_CATEGORY_SUCCESS,
    actionTypes.EDIT_EXPENSE_CATEGORY_ERROR,
  ],
  callAPI: () =>
    fetch({
      url: `${Angie.api_url}/expense-categories/${id}`,
      method: "PUT",
      body: attributes,
    }),
  payload: {
    ...attributes,
    schema: {
      single: expenseCategory,
    },
  },
});

export const deleteExpenseCategoryAction = (id, is_in_use = true) => ({
  types: [
    actionTypes.DELETE_EXPENSE_CATEGORY_LOADING,
    actionTypes.DELETE_EXPENSE_CATEGORY_SUCCESS,
    actionTypes.DELETE_EXPENSE_CATEGORY_ERROR,
  ],
  callAPI: () =>
    fetch({
      url: `${Angie.api_url}/expense-categories/${id}`,
      method: "DELETE",
    }),
  payload: {
    id,
    is_in_use,
  },
});

export const deleteExpenseCategoryFromEventStream = (id) => {
  return {
    type: actionTypes.DELETE_EXPENSE_CATEGORY_FROM_EVENT_STREAM,
    id,
  };
};
